// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__1svpD","textarea":"styles_textarea__gth0c"};